import React, { useState, useEffect } from 'react';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import './CustomAccordion.css';

const CustomAccordion = ({ services, options, onAccordionClick, activeKey }) => {
  const [expandedIndex, setExpandedIndex] = useState(0); // First item expanded by default

  // Update expanded index when activeKey changes from parent
  useEffect(() => {
    if (activeKey && services) {
      const activeSlug = activeKey.replace('#', '');
      const activeIndex = services.findIndex(service => service.Slug === activeSlug);
      if (activeIndex !== -1) {
        setExpandedIndex(activeIndex);
      }
    }
  }, [activeKey, services]);

  const toggleAccordion = (index) => {
    const newExpandedIndex = expandedIndex === index ? -1 : index;
    setExpandedIndex(newExpandedIndex);
    
    // Notify parent component about the change
    if (newExpandedIndex !== -1 && onAccordionClick) {
      onAccordionClick(services[newExpandedIndex].Slug);
    }
  };

  if (!services || services.length === 0) {
    return null;
  }

  return (
    <div className="custom-accordion-container">
      {services.map((item, index) => (
        <div key={index} className="custom-accordion-item">
          <button
            className={`custom-accordion-header ${expandedIndex === index ? 'expanded' : ''}`}
            onClick={() => toggleAccordion(index)}
            aria-expanded={expandedIndex === index}
            aria-controls={`accordion-content-${index}`}
            type="button"
          >
            <div className="custom-accordion-header-content">
              <span className="custom-accordion-icon">
                <img src={item.Icon} alt={`${item.Title} icon`} />
              </span>
              <h3 className={`custom-accordion-title ${expandedIndex === index ? '' : ''}`}>
                {item.Title}
              </h3>
            </div>
            <svg
              className={`custom-accordion-arrow ${expandedIndex === index ? 'expanded' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          <div
            id={`accordion-content-${index}`}
            className={`custom-accordion-body ${expandedIndex === index ? '' : 'collapsed'}`}
            role="region"
            aria-labelledby={`accordion-header-${index}`}
          >
            {expandedIndex === index && (
              <div className="custom-accordion-content">
                {/* IMAGE FIRST */}
                {item.Image && (
                  <img
                    src={item.Image}
                    alt={item.Title}
                    className="custom-accordion-image-contain"
                  />
                )}
                
                {/* TITLE SECOND */}
                <h4 className="custom-accordion-content-title" style={{color:"#000099"}}>
                  {item.Title}
                </h4>
                
                {/* DESCRIPTION THIRD */}
                <div className="custom-accordion-description custom-accordion-description-truncated">
                  {item?.Desc?.map((info, id) => (
                    <div key={id}>
                      {documentToReactComponents(info, options)}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomAccordion;